import React from "react";
import { Link, useLocation } from "react-router-dom";

function PageNotFound({ isSidebarExpanded }) {
  const location = useLocation();

  return (
    <div
      className={`page-not-found-content page-content ${
        isSidebarExpanded ? "expanded" : "collapsed"
      }`}
    >
      <div className="page-not-found-card">
        <div className="page-not-found-code">404</div>
        <h1>Page Not Found</h1>
        <p>
          The page you are looking for does not exist or the route is no longer
          available.
        </p>
        <div className="page-not-found-path">{location.pathname}</div>
        <Link className="page-not-found-button" to="/dashboard">
          Go to Dashboard
        </Link>
      </div>
    </div>
  );
}

export default PageNotFound;
